import React, {Component} from 'react'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl'
import Calculator from '../../../common/Calculator.js'
import FormattedInputField from '../../../sharedComponents/formattedInputField.component.jsx'

class CalculatorFormulaForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            formula: '',
            partName: '',
            partId: '',
            calculatorFormulaId: '',
            simulation: '',
            terms: [],
            vars: {},
            index: 0,
            testMode: false,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteValue = this.deleteValue.bind(this)
        this.changeValue = this.changeValue.bind(this)
        this.toggleTestMode = this.toggleTestMode.bind(this)
    }

    componentDidMount() {
        const value =  this.props.value || {}
        this.setState({
            formula: value.formula || '',
            partName: value.partName || '',
            partId: value.partId || '',
            calculatorFormulaId: value.calculatorFormulaId || '',
            index: this.props.index || 0,
            terms: this.props.terms || [],
        }, () => {
            this.simulateFormula()
        })
    }

    componentWillReceiveProps(nextProps) {
        const value =  nextProps.value || {}
        this.setState({
            formula: value.formula || '',
            partName: value.partName || '',
            partId: value.partId || '',
            calculatorFormulaId: value.calculatorFormulaId || '',
            index: nextProps.index || 0,
            terms: nextProps.terms || [],
        }, () => {
            this.simulateFormula()
        })
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }, () => {
            this.simulateFormula()
            this.changeValue()
        })
    }

    deleteValue(e) {
        e.preventDefault()
        const onDelete = this.props.onDelete || function() {}
        onDelete(this.state.index)
    }

    changeValue() {
        const onChange = this.props.onChange || function() {}
        onChange({
            formula: this.state.formula,
            partId: this.state.partId,
            partName: this.state.partName,
            calculatorFormulaId: this.state.calculatorFormulaId,
        })
    }

    simulateFormula() {
        let result = ''
        if (this.state.formula) {
            const calculator = new Calculator(this.state.formula)
            // let vars = {}
            // for (let index in this.state.terms) {
            //     const term = this.state.terms[index]
            //     vars[term.variableName] = term.simulation
            // }
            result = calculator.execute(this.state.vars)
        }

        this.setState({
            simulation: result
        })
    }

    toggleTestMode(event) {
        event.preventDefault()
        this.setState({
            testMode: !this.state.testMode
        })
    }

    render() {
        const messages = defineMessages({
            "formula_placeholder": {
                id: 'product.edit.form.calculator.term.item_formula_placeholder',
                defaultMessage: 'Formula',
            },
            "simulation_placeholder": {
                id: 'product.edit.form.calculator.term.item_simulation_placeholder',
                defaultMessage: 'Simulation',
            },
        })

        let testFormula = ''
        if (this.state.testMode) {
            testFormula = <div className="row">
                <div className="col-6">
                    {this.state.terms.map(t => {
                        return <div className="form-group mb-0">
                            <label>
                                {t.name} (<strong>{t.variableName}</strong>)
                            </label>
                            <FormattedInputField name={t.variableName}
                                                 id={t.variableName}
                                                 type="text"
                                                 className="form-control"
                                                 placeholder={this.props.intl.formatMessage(messages['simulation_placeholder'])}
                                                 valueType="decimal"
                                                 value={this.state.vars[t.variableName]}
                                                 onValueChange={(newValue) => {
                                                     const vars = this.state.vars
                                                     vars[t.variableName] = newValue
                                                     this.setState({
                                                         vars: vars
                                                     }, () => {
                                                         this.simulateFormula()
                                                     })
                                                 }}
                            />
                        </div>
                    })}
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <label>
                            <FormattedMessage
                                id="product.assembly.form.result_formula_label"
                                defaultMessage="Result"
                            />
                        </label>
                        <p>
                            <strong>{this.state.simulation}</strong>
                        </p>
                    </div>
                </div>
                <strong>{this.state.partName}</strong>
            </div>
        }
        return (
            <div className="row pt-2">
                <div className="col-12">
                    <div className="form-group">
                        <label>
                            <FormattedMessage
                                id="product.assembly.form.formula_label"
                                defaultMessage="Formula"
                            />
                        </label>
                        <input
                            name="formula"
                            value={this.state.formula}
                            onChange={this.handleFormChange}
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage(messages['formula_placeholder'])}
                        />
                        <small>
                            <p className="m-0 p-0">
                                <u>
                                    <FormattedMessage
                                        id="product.assembly.form.variables_label"
                                        defaultMessage="Variables:"
                                    />
                                </u>
                            </p>
                            {this.state.terms.map(t => {
                                return <p className="m-0 p-0" key={t.variableName}>
                                    {t.name} (<strong>{t.variableName}</strong>)
                                </p>
                            })}
                        </small>
                    </div>
                    <div className="form-group">
                        <a href="#" onClick={this.toggleTestMode}>
                            <FormattedMessage
                                id="product.assembly.form.test_mode_link"
                                defaultMessage="Try it!"
                            />
                        </a>
                    </div>
                    {testFormula}
                </div>

            </div>
        );
    }
}

export default injectIntl(CalculatorFormulaForm)


// WEBPACK FOOTER //
// ./src/product/form/calculator/formula.component.jsx